import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material/styles';
import React from 'react';
import * as AnalyticsService from '../../analytics/AnalyticsService.js';
import { track } from '../../analytics/AnalyticsService.js';
import 'branch-sdk';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import '../../analytics/types.js';
import '../../analytics/metaPixel.js';
import '../../analytics/fingerprint.js';

const MessageCardWrapper = styled('div')(() => ({
    boxSizing: 'border-box',
    textAlign: 'center',
    border: `1px solid #dcdddc`,
    borderRadius: 10,
    padding: '27px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f6f8fa',
    gap: 10,
}));
const MessageCardTitle = styled('div')(({ theme }) => ({
    fontSize: 20,
    fontWeight: 700,
    color: theme.vars.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
        fontSize: 18,
    },
}));
const MessageCardContent = styled('div')(({ theme }) => ({
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.text.primary,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        fontSize: 14,
    },
}));
const MessageActionButton = styled('button')(({ theme }) => ({
    marginTop: 10,
    height: 50,
    fontSize: 16,
    whiteSpace: 'nowrap',
    padding: '0 20px',
    fontWeight: 600,
    borderRadius: '999px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 355,
    border: 'none',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
        minWidth: 'unset',
        height: 44,
        fontSize: 14,
    },
}));
const MessageCard = (_a) => {
    var { title, content, cta, onActionClick, linkTo, trackedEventName, trackingParams } = _a, props = __rest(_a, ["title", "content", "cta", "onActionClick", "linkTo", "trackedEventName", "trackingParams"]);
    return (React.createElement(MessageCardWrapper, Object.assign({}, props),
        React.createElement(MessageCardTitle, { className: "store-message-card__title" }, title),
        React.createElement(MessageCardContent, { className: "store-message-card__content" }, content),
        React.createElement(MessageActionButton, { className: "store-message-card__cta", onClick: (e) => {
                AnalyticsService === null || AnalyticsService === void 0 ? void 0 : track(trackedEventName || AnalyticsTrackingEvent.BUTTON_CLICK, Object.assign({ buttonName: cta, linkTo }, trackingParams));
                onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(e);
            } }, cta)));
};

export { MessageCard as default };
//# sourceMappingURL=MessageCard.js.map
